// extracted by mini-css-extract-plugin
export default {"disabled":"TermDurationPicker_disabled__R2aUl"};